import React from 'react';
import PropTypes from 'prop-types';
import { FormattedPlural } from 'react-intl';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import { statusColours } from '../../constants/ColourConstants';
import ComplianceIcon from 'material-ui/svg-icons/action/assignment-turned-in';
import SkillChip from '../Skill/SkillChip';

import { CircularProgressbar, buildStyles } from 'react-circular-progressbar/dist/index';
import 'react-circular-progressbar/dist/styles.css';

const today = new Date();

const renderSkills = (skills, acquiredList, userId = null) => ( skills && skills.length > 0 ) && (skills.map(({id, name}) => {

    let disabled = true;

    if (acquiredList[id]) {
        disabled = false;
        if (acquiredList[id].expired) {
            const expired = new Date(acquiredList[id].expired);
            disabled =  (+expired <= +today);
        }
    }

    return (<SkillChip key={id} skill={{id, name}} disabled={disabled} userId={userId} />);

}));


const ComplianceSegment = ({userId, complianceId, name='Compliance', skillAcquired, skills = [], userSkills = []}) => {

    const totalSkills = skills.length;
    const totalUserSkills = skillAcquired; //userSkills.length;
    const percentage = Math.round((totalUserSkills / totalSkills) *100);

    const acquiredList = userSkills ? userSkills.reduce((ac, {id, acquired, expired}) => ({...ac, [id]: {acquired, expired}}), {}) : {};


    return (
        <Card className="cent-card cent-card-6">
            <CardHeader
                title={name}
                subtitle={(<span>
                        {totalUserSkills} of {totalSkills} <FormattedPlural value={totalSkills || 0} one='skill' other='skills' /> acquired
                </span>
                )}
                avatar={<ComplianceIcon color={statusColours.default} />}
            />

                <CardText className="cent-zero" >
                    <div className="cent-content">
                        <div className="content-left">
                            <div className={'cent-progress-bar-circular'}>

                            <CircularProgressbar
                                strokeWidth={12}
                                value={totalUserSkills}
                                maxValue={totalSkills}
                                text={`${percentage}%`}

                                styles={buildStyles({
                                    rotation: 0.25,
                                    strokeLinecap: 'butt',
                                    textSize: '18px',
                                    pathTransitionDuration: 0.5,
                                    pathColor: statusColours.primary,
                                    textColor: statusColours.default,
                                    trailColor: statusColours.disabled,
                                    backgroundColor: statusColours.primary_2,
                                })}
                            />
                            </div>
                        </div>
                        <div className="content-main">
                            <div className="cent-card-chips-r">
                                {renderSkills(skills, acquiredList, userId)}
                            </div>
                        </div>
                    </div>
                </CardText>
        </Card>
    );
};

ComplianceSegment.propTypes = {
    userId: PropTypes.number,
    name: PropTypes.string,
    skills: PropTypes.array,
    userSkills: PropTypes.array,
};

export default ComplianceSegment;
